import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/integration/react';
import { Store, persistor } from './redux/store';

import { AppRouter } from './router/AppRouter';
import { ErrorBoundary } from './components/errorBoundary/ErrorBoundary';

export const App = () => {

	return (
		<Provider store={Store}>
			<ErrorBoundary>
				<PersistGate loading={null} persistor={persistor}>
					<AppRouter />
				</PersistGate>
			</ErrorBoundary>
		</Provider>
	)
}
